export default __webpack_public_path__ + "static/media/yards.51bfcf1a.svg";